import React from 'react';
import { cx, css } from 'linaria';

const titleStyle = css`
  font-size: 28px;
  font-weight: 400;
  line-height: 36px;
  margin-bottom: 1.5rem;
  text-align: center;
`;

export const fadeInStyle = css`
  animation: fadeInAnimation 0.5s ease-in-out;

  @keyframes fadeInAnimation {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ContentTitle = ({ text, asH1 = false, ...props }) => {
  if (asH1) {
    return (
      <h1 className={cx('content-title', titleStyle, fadeInStyle)} {...props}>
        {text}
      </h1>
    );
  }
  return (
    <h2 className={cx('content-title', titleStyle, fadeInStyle)} {...props}>
      {text}
    </h2>
  );
};
